import { useState } from "react";
import { Button } from "@mui/material";

export default function JsonViewer({ json }) {
  const [expanded, setExpanded] = useState(false);

  if (!json) return <span>—</span>;

  let parsed;
  try {
    parsed = JSON.parse(json);
  } catch {
    return <span>Invalid JSON</span>;
  }

  return (
    <div style={{ marginTop: 5 }}>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Hide" : "Show"} JSON
      </Button>

      {expanded && (
        <pre
          style={{
            background: "#f5f5f5",
            padding: 10,
            marginTop: 10,
            borderRadius: 4,
            maxHeight: 300,
            overflow: "auto"
          }}
        >
          {JSON.stringify(parsed, null, 2)}
        </pre>
      )}
    </div>
  );
}
